module.exports = __webpack_public_path__ + "static/rowIcon4.685fbd3e.svg";